import React, { useState } from 'react';
import ConfirmDestructiveDialog from '@/components/ConfirmDestructiveDialog';
import { InlineToggle } from '@/components/ui';

type Props = {
  selectedCount: number;
  alsoDeleteRelatedJobs: boolean;
  onAlsoDeleteRelatedJobsChange: (value: boolean) => void;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export default function CleanupActivityConfirmModal({
  selectedCount,
  alsoDeleteRelatedJobs,
  onAlsoDeleteRelatedJobsChange,
  onClose,
  onConfirm,
}: Props) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function confirm() {
    setSubmitting(true);
    setError('');
    try {
      await onConfirm();
      onClose();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Cleanup failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <ConfirmDestructiveDialog
      title="Clear selected activity logs?"
      onClose={onClose}
      closeOnBackdrop={!submitting}
      footer={
        <>
          <button type="button" className="btn btn-ghost" disabled={submitting} onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-danger" disabled={submitting} onClick={() => void confirm()}>
            {submitting ? 'Removing…' : 'Clear logs'}
          </button>
        </>
      }
    >
      {error && <div className="alert alert-error">{error}</div>}

      <p className="modal-lead">
        Remove <strong>{selectedCount}</strong> delivery record(s) from the activity log?
      </p>

      <InlineToggle
        checked={alsoDeleteRelatedJobs}
        onChange={onAlsoDeleteRelatedJobsChange}
        disabled={submitting}
        label="Also clear related jobs"
      />

      <p className="modal-hint muted">Removes linked terminal jobs only. Discovered listing rows are not deleted.</p>
    </ConfirmDestructiveDialog>
  );
}
